import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

// UGC sub modules
import placements from "./placements";
import stateManager from "./stateManager";
import storageController from "./storageController";
import tempData from "./tempData";

const moduleUgc = {
  actions,
  getters,
  mutations,
  modules: {
    placements,
    stateManager,
    storageController,
    tempData
  },
  namespaced: true,
  state: {
    template_guide_outer_bgcolor_dark: "#010202",
    template_guide_outer_bgcolor_light: "#e1e1e1",
    template_guide_outer_textcolor_dark: "#000000",
    template_guide_bg: "#F2F2F2",
    savedUGCMesh: {},
    tonalStitch: {},
    gcc_flow: false,
    isUGCLoadingFromEntrypoint: null, // null: no ugc entrypoint, 1: ugcImage, 2: secondaryImage
    ugcBlockedPalettes: {},
    availableUgcFeatures: [
      "holidaytool",
      "checkerboarder",
      "crayola"
    ],
  }
};

export default moduleUgc;
